<template>
    <div class="painel">
        <loader object="#df3e46" v-show="progress" color1="#0db9d3" color2="#fff01f" size="6" speed="2.4" bg="#C0C0C0"
            objectbg="#0d0c0d" opacity="50" name="circular"></loader>

        <div class=" ml-3 mt-2 mr-3">
            <div class=" mt-2">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-6 text-left">
                                <a class="btn btn-light" id="collapseFiltroBTN" data-toggle="collapse" href="#collapseFiltro" role="button"
                                    aria-expanded="true" aria-controls="collapseFiltro">
                                    <i class="text-muted fas fa-stream mr-2"></i>
                                    Filtro
                                </a>
                            </div>

                        </div>

                        <div class="collapse" id="collapseFiltro">
                            <div class="font-13 pt-2">

                                <div class="mt-2 row border rounded-top font-weight-bold">
                                    <div class="text-center bg-light col-6 border-right border-white">
                                        Projeto
                                    </div>
                                    <div class="text-center bg-light col-6">
                                        Atividade
                                    </div>
                                </div>
                                <div class="row">

                                    <!-- div Projeto -->
                                    <div class="col-6 py-1 bg-light border-left border-right">
                                        <div class="form-check">
                                            <div class="row">
                                                <div class="col-4">
                                                    <input class="form-check-input" type="checkbox" value="true"
                                                        v-model="filtro.projetosituacaoNI" id="sitProjetoCheck1">
                                                    <label class="form-check-label" for="sitProjetoCheck1">
                                                        Não Iniciado
                                                    </label>
                                                </div>
                                                <div class="col-4">
                                                    <input class="form-check-input" type="checkbox" value="true"
                                                        v-model="filtro.projetosituacaoEA" id="sitProjetoCheck2">
                                                    <label class="form-check-label" for="sitProjetoCheck2">
                                                        Em Andamento
                                                    </label>
                                                </div>
                                                <div class="col-4">
                                                    <input class="form-check-input" type="checkbox" value="true"
                                                        v-model="filtro.projetosituacaoVA" id="sitProjetoCheck8">
                                                    <label class="form-check-label" for="sitProjetoCheck8">
                                                        Aguardando Validação
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-4">
                                                    <input class="form-check-input" type="checkbox" value="true"
                                                        v-model="filtro.projetosituacaoCA" id="sitProjetoCheck7">
                                                    <label class="form-check-label" for="sitProjetoCheck7">
                                                        Cancelado
                                                    </label>
                                                </div>
                                                <div class="col-4">
                                                    <input class="form-check-input" type="checkbox" value="true"
                                                        v-model="filtro.projetosituacaoCO" id="sitProjetoCheck3">
                                                    <label class="form-check-label" for="sitProjetoCheck3">
                                                        Concluído
                                                    </label>
                                                </div>
                                                <div class="col-4">
                                                    <input class="form-check-input" type="checkbox" value="true"
                                                        v-model="filtro.projetosituacaoRE" id="sitProjetoCheck5">
                                                    <label class="form-check-label" for="sitProjetoCheck5">
                                                        Rejeitado
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-4">
                                                    <input class="form-check-input" type="checkbox" value="true"
                                                        v-model="filtro.projetosituacaoAT" id="sitProjetoCheck4">
                                                    <label class="form-check-label" for="sitProjetoCheck4">
                                                        Atrasado
                                                    </label>
                                                </div>
                                                <div class="col-4">
                                                    <input class="form-check-input" type="checkbox" value="true"
                                                        v-model="filtro.projetoReagendado" id="sitProjetoCheck9">
                                                    <label class="form-check-label" for="sitProjetoCheck9">
                                                        Reagendado
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mt-2 row font-weight-bold">
                                            <div class="col">
                                                <div class="ml-2">Data Inicial</div>
                                                <flat-picker tabindex="1" id="dataInicio" autocomplete="off"
                                                    class="font-13 form-control datepicker" placeholder="Data Inicial"
                                                    v-model="filtro.projetoDataInicio" :config="{
                                                        allowInput: true,
                                                        dateFormat: 'd/m/Y',
                                                        altFormat: 'M j, Y',
                                                    }" />
                                            </div>
                                            <div class="col">
                                                <div class="ml-2">Data Final</div>
                                                <flat-picker tabindex="2" id="dataFim"
                                                    class="font-13 form-control datepicker" placeholder="Data Final"
                                                    autocomplete="off" v-model="filtro.projetoDataFim" :config="{
                                                        allowInput: true,
                                                        dateFormat: 'd/m/Y',
                                                        altFormat: 'M j, Y',
                                                    }" />
                                            </div>
                                            <div class="col">
                                                <div class="ml-2">Data de Conclusão</div>
                                                <flat-picker tabindex="3" id="dataConclusao" autocomplete="off"
                                                    class="font-13 form-control datepicker" placeholder="Data de Conclusão"
                                                    v-model="filtro.projetoDataConclusao" :config="{
                                                        allowInput: true,
                                                        dateFormat: 'd/m/Y',
                                                        altFormat: 'M j, Y',
                                                    }" />
                                            </div>
                                        </div>
                                        <div class="mt-2 row bg-light">
                                            <div class="col">
                                                <div class="ml-2 font-weight-bold">Projeto criado por</div>
                                                <v-select class="mb-2" placeholder="Selecione Usuário" label="nome" multiple
                                                    :reduce="(u) => u.idusuario" v-model="filtro.projetocriador"
                                                    :options="listaUsuarios">
                                                    <span slot="no-options" @click="$refs.select.open = false">
                                                        Nenhum registro encontrado
                                                    </span>
                                                </v-select>
                                            </div>
                                            <div class="col">
                                                <div class="ml-2 font-weight-bold">Responsável</div>
                                                <v-select class="mb-2" placeholder="Selecione Responsável" label="nome"
                                                    multiple :reduce="(u) => u.idusuario"
                                                    v-model="filtro.projetoresponsavel" :options="listaUsuarios">
                                                    <span slot="no-options" @click="$refs.select.open = false">
                                                        Nenhum registro encontrado
                                                    </span>
                                                </v-select>
                                            </div>
                                        </div>
                                        <div class="mt-2 row bg-light">
                                            <div class="col">
                                                <div class="ml-2 font-weight-bold">Classificação</div>
                                                <v-select class="mb-2" placeholder="Selecione a Classificação"
                                                    label="descricao" multiple :reduce="(c) => c.codigo"
                                                    v-model="filtro.classificacao" :options="listaClassificacao">
                                                    <span slot="no-options" @click="$refs.select.open = false">
                                                        Nenhum registro encontrado
                                                    </span>
                                                </v-select>
                                            </div>
                                            <div class="col">
                                                <div class="ml-2 font-weight-bold">Relevância</div>
                                                <v-select class="mb-2" placeholder="Selecione a Relevância"
                                                    label="descricao" multiple :reduce="(c) => c.codigo"
                                                    v-model="filtro.relevancia" :options="listaRelevancia">
                                                    <span slot="no-options" @click="$refs.select.open = false">
                                                        Nenhum registro encontrado
                                                    </span>
                                                </v-select>
                                            </div>
                                            <div class="col">
                                                <div class="ml-2 font-weight-bold">Grupo de Trabalho</div>
                                                <v-select class="mb-2" placeholder="Selecione o Grupo" label="nomeComCoord"
                                                    multiple :reduce="(c) => c.idgt" v-model="filtro.grupoTrabalho"
                                                    :options="listaGT">
                                                    <span slot="no-options" @click="$refs.select.open = false">
                                                        Nenhum registro encontrado
                                                    </span>
                                                </v-select>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- div Atividade -->
                                    <div class="col-6 py-1 bg-light border-right">
                                        <div class="form-check">
                                            <div class="row">
                                                <div class="col-4">
                                                    <input class="form-check-input" type="checkbox" value="true"
                                                        v-model="filtro.atividadesituacaoNI" id="sitAtividadeCheck1">
                                                    <label class="form-check-label" for="sitAtividadeCheck1">
                                                        Não Iniciada
                                                    </label>
                                                </div>
                                                <div class="col-4">
                                                    <input class="form-check-input" type="checkbox" value="true"
                                                        v-model="filtro.atividadesituacaoEA" id="sitAtividadeCheck2">
                                                    <label class="form-check-label" for="sitAtividadeCheck2">
                                                        Em Andamento
                                                    </label>
                                                </div>
                                                <div class="col-4">
                                                    <input class="form-check-input" type="checkbox" value="true"
                                                        v-model="filtro.atividadedestaque" id="atividadedestaque">
                                                    <label class="form-check-label" for="atividadedestaque">
                                                        Destaque
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-4">
                                                    <input class="form-check-input" type="checkbox" value="true"
                                                        v-model="filtro.atividadesituacaoCA" id="sitAtividadeCheck6">
                                                    <label class="form-check-label" for="sitAtividadeCheck6">
                                                        Cancelada
                                                    </label>
                                                </div>
                                                <div class="col-4">
                                                    <input class="form-check-input" type="checkbox" value="true"
                                                        v-model="filtro.atividadesituacaoCO" id="sitAtividadeCheck3">
                                                    <label class="form-check-label" for="sitAtividadeCheck3">
                                                        Concluída
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-4">
                                                    <input class="form-check-input" type="checkbox" value="true"
                                                        v-model="filtro.atividadesituacaoAT" id="sitAtividadeCheck4">
                                                    <label class="form-check-label" for="sitAtividadeCheck4">
                                                        Atrasada
                                                    </label>
                                                </div>
                                                <div class="col-4">
                                                    <input class="form-check-input" type="checkbox" value="true"
                                                        v-model="filtro.atividadeReagendada" id="atividadeRA">
                                                    <label class="form-check-label" for="atividadeRA">
                                                        Reagendada
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mt-2 row font-weight-bold">
                                            <div class="col">
                                                <div class="ml-2">Data Inicial</div>
                                                <flat-picker tabindex="1" id="dataInicio" autocomplete="off"
                                                    class="font-13 form-control datepicker" placeholder="Data Inicial"
                                                    v-model="filtro.atividadeDataInicio" :config="{
                                                        allowInput: true,
                                                        dateFormat: 'd/m/Y',
                                                        altFormat: 'M j, Y',
                                                    }" />
                                            </div>
                                            <div class="col">
                                                <div class="ml-2">Data Final</div>
                                                <flat-picker tabindex="2" id="dataFim" autocomplete="off"
                                                    class="font-13 form-control datepicker" placeholder="Data Final"
                                                    v-model="filtro.atividadeDataFim" :config="{
                                                        allowInput: true,
                                                        dateFormat: 'd/m/Y',
                                                        altFormat: 'M j, Y',
                                                    }" />
                                            </div>
                                            <div class="col">
                                                <div class="ml-2">Data de Conclusão</div>
                                                <flat-picker tabindex="3" id="dataConclusao"
                                                    class="font-13 form-control datepicker" placeholder="Data de Conclusão"
                                                    v-model="filtro.atividadeDataConclusao" :config="{
                                                        allowInput: true,
                                                        dateFormat: 'd/m/Y',
                                                        altFormat: 'M j, Y',
                                                    }" />
                                            </div>
                                        </div>
                                        <div class="mt-2 row">
                                            <div class="col">
                                                <div class="ml-2 font-weight-bold">Atividade criada por</div>
                                                <v-select class="mb-2" placeholder="Selecione Usuário" label="nome" multiple
                                                    :reduce="(u) => u.idusuario" v-model="filtro.atividadecriador"
                                                    :options="listaUsuarios">
                                                    <span slot="no-options" @click="$refs.select.open = false">
                                                        Nenhum registro encontrado
                                                    </span>
                                                </v-select>
                                            </div>
                                            <div class="col">
                                                <div class="ml-2 font-weight-bold">Responsável</div>
                                                <v-select class="mb-2" placeholder="Selecione Responsável" label="nome"
                                                    multiple :reduce="(u) => u.idusuario"
                                                    v-model="filtro.atividaderesponsavel" :options="listaUsuarios">
                                                    <span slot="no-options" @click="$refs.select.open = false">
                                                        Nenhum registro encontrado
                                                    </span>
                                                </v-select>
                                            </div>
                                        </div>
                                        <div class="mt-2 row bg-light">
                                            <div class="col">
                                                <div class="ml-2 font-weight-bold">Investimento</div>
                                                <v-select class="mb-2" placeholder="Selecione o Investimento"
                                                    label="descricao" :reduce="(c) => c.codigo"
                                                    v-model="filtro.investimento" :options="listaInvestimento">
                                                    <span slot="no-options" @click="$refs.select.open = false">
                                                        Nenhum registro encontrado
                                                    </span>
                                                </v-select>
                                            </div>
                                            <div class="col">
                                                <div class="ml-2 font-weight-bold">Tipo de Atividade</div>
                                                <v-select class="mb-2" placeholder="Selecione o Tipo de Atividade"
                                                    label="nome" multiple :reduce="(c) => c.idsubtipoatividade"
                                                    v-model="filtro.tipoAtividade" :options="listaTipoAtividade">
                                                    <span slot="no-options" @click="$refs.select.open = false">
                                                        Nenhum registro encontrado
                                                    </span>
                                                </v-select>
                                            </div>
                                            <div class="col">
                                                <div class="ml-2 font-weight-bold">Grupo de Trabalho</div>
                                                <v-select class="mb-2" placeholder="Selecione o Grupo" label="nomeComCoord"
                                                    multiple :reduce="(c) => c.idgt" v-model="filtro.grupoTrabalhoAtividade"
                                                    :options="listaGT">
                                                    <span slot="no-options" @click="$refs.select.open = false">
                                                        Nenhum registro encontrado
                                                    </span>
                                                </v-select>
                                            </div>
                                        </div>
                                        <div class="mt-2 row bg-light">
                                            <div class="col mt--2">
                                                <div class="input-group">
                                                    <div class="input-group-prepend mr-n1" style="height: 30px;">
                                                        <span class="input-group-text pt-2 pb-2"
                                                            style="font-size: 13px !important;">R$</span>
                                                    </div>
                                                    <vue-numeric style="font-size: 13px; height: 30px;"
                                                        placeholder="Valor de Investimento" class="form-control"
                                                        v-model="filtro.valorInvestimento" separator="."
                                                        v-bind:precision="2" v-bind:minus="false">
                                                    </vue-numeric>
                                                </div>
                                            </div>
                                            <div class="col">
                                            </div>
                                            <div class="col">
                                            </div>
                                        </div>
                                        <div class="text-right mr-2 mt--3">
                                            <a class="btn btn-light" @click.prevent="limparFiltro">
                                                <i class="fas fa-eraser mr-2"></i>
                                                Limpar Filtro
                                            </a>
                                            <a class="btn btn-info" @click.prevent="carregarProjetos">
                                                <i class="fas fa-filter mr-2"></i>
                                                Aplicar
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="ml-3 mt-2 mr-3">
            <!-- Painel Projeto do <strong>GT - Bichos peçonhentos</strong> -->
            <gantt-elastic :tasks="tasks" :options="options" @chart-project-click="abrirModalProjeto"
                @chart-milestone-click="abrirModalProjeto" @chart-task-click="abrirModalProjeto">
                <gantt-header :options="userOptions" slot="header"></gantt-header>
            </gantt-elastic>
        </div>

        <modal :show.sync="modals.modalProjeto" size="lg">
            <div class="row mb-1 p-1">
                <div class="col-8">
                    <strong>Projeto:</strong> {{ projeto.codigo }} - {{ projeto.label }}
                </div>
                <div class="col-4 text-right">
                    <strong>Situação:</strong> {{ projeto.situacao }}
                    <span v-if="projeto.situacao == 'Em Andamento'">({{ projeto.progress }}%)</span>
                </div>
            </div>
            <div class="w-100 p-1">
                <strong>Período:</strong> {{ projeto.inicio }} até {{ projeto.fim }}
                ({{ projeto.duracao }} dias)
            </div>
            <div class="w-100 p-1" v-if="projeto.dataConclusao != null">
                <strong>Conclusão:</strong> {{ projeto.dataConclusao }}
            </div>
            <div class="row p-1">
                <div class="col">
                    <strong>Classificação:</strong> {{ projeto.classificacao }}
                </div>
                <div class="col">
                    <strong>Relevância:</strong> {{ projeto.relevancia }}
                </div>
            </div>
            <div class="row p-1">
                <div class="col">
                    <strong>Grupo(s) de Trabalho:</strong> <br />
                    <span class="ml-2" v-for="gt in projeto.listaGT" :key="gt.idgt">
                        - {{ gt.nome }}<br />
                    </span>
                </div>
                <div class="col">
                    <strong>Responsável(is):</strong> <br />
                    <span class="ml-2" v-for="r in projeto.listaResp" :key="r.idusuario">
                        - {{ r.nome }}<br />
                    </span>
                </div>
            </div>
            <br class="clear" />
            <div class="col-md-12 text-center mt-3">
                <button type="button" class="btn btn-danger ml-4" @click="fecharModalProjeto">
                    Fechar
                </button>
            </div>
        </modal>
    </div>
</template>

<script>
import GanttElastic from 'gantt-elastic';
import Header from "gantt-elastic-header";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
    components: {
        "gantt-header": Header,
        "gantt-elastic": GanttElastic,
        flatPicker
    },
    created() {
        const { startDate, endDate } = this.getDateRange();
        this.filtro.projetoDataInicio = startDate;
        this.filtro.projetoDataFim = endDate;
        this.carregarProjetos();
        this.carregarTela();
    },
    data() {
        return {
            progress: true,
            filtro: {
                ordem: 5,
            },
			listaProjeto: [],
			listaProjetoFiltro: [],
			listaClassificacao: [],
			listaRelevancia: [],
			listaInvestimento: [],
			listaTipoAtividade: [],
			listaGT: [],
			listaUsuarios: [],
            modals: {
                modalProjeto: false,
            },
            projeto: {},
            unwatchTasks: {},
            userOptions: {
                title: {
                    label: "",
                    html: true,
                },
                locale: {
                    Now: "Hoje",
                    "X-Scale": "Escala X",
                    "Y-Scale": "Escala Y",
                    "Task list width": "Lista de projetos",
                    "Before/After": "Expandir",
                    "Display task list": "Projetos",
                },
            },
            tasks: [],
            options: {
                calendar: {
                    hour: {
                        display: false,
                    },
                },
                locale: {
                    //*
                    name: 'en',
                    weekdays: 'Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado'.split('_'),
                    weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sab'.split('_'),
                    weekdaysMin: 'D_S_T_Q_Q_S_S'.split('_'),
                    months: 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
                    monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
                    weekStart: 1,
                    relativeTime: {
                        future: 'em %s',
                        past: '%s atrás',
                        s: 'em segundos',
                        m: 'um minuto',
                        mm: '%d minutos',
                        h: 'uma hora',
                        hh: '%d horas',
                        d: 'um dia',
                        dd: '%d dias',
                        M: 'um mês',
                        MM: '%d meses',
                        y: 'um ano',
                        yy: '%d anos'
                    },
                    formats: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY HH:mm',
                        LLLL: 'dddd, D MMMM YYYY HH:mm'
                    },
                    ordinal: n => {
                        const s = ['th', 'st', 'nd', 'rd'];
                        const v = n % 100;
                        return `[${n}${s[(v - 20) % 10] || s[v] || s[0]}]`;
                    }
                },
                title: {
                    label: 'Título',
                    html: true,
                    style: {
                        'font-size': '20px',
                        'vertical-align': 'middle',
                        'font-weight': '400',
                        'line-height': '35px',
                        'padding-left': '22px',
                        'letter-spacing': '1px'
                    }
                },
                taskList: {
                    expander: {
                        straight: true,
                    },
                    columns: [
                        {
                            id: 1,
                            label: 'Projeto',
                            value: 'titulo',
                            width: 280,
                            style: {
                                'task-list-header-label': {
                                    'font-weight': 'bold',
                                },
                                'task-list-item-value': {
                                    'font-weight': 'bold',
                                    'cursor': 'pointer',
                                }
                            },
                            events: {
                                click: ({ data }) => {
                                    this.abrirModalProjeto(data);
                                }
                            },
                            expander: false
                        }, /*{
                            id: 2,
                            label: 'Projeto',
                            value: 'label',
                            width: 220,
                            style: {
                                'task-list-header-label': {
                                    'font-weight': 'bold',
                                },
                                /*
                                'task-list-item-value': {
                                    cursor: 'pointer',
                                    'color': '#0077c0'
                                },
                                */
                            /*},
                            events: {
                                click({ data }) {
                                    //alert('description clicked!\n' + data.id +" - "+ data.type);
                                    //this.abrirModalProjeto(data);
                                }
                            },
                            expander: true
                        }, */{
                            id: 3,
                            label: 'Responsável',
                            value: 'user',
                            width: 100,
                            style: {
                                'task-list-header-label': {
                                    'font-weight': 'bold',
                                },
                                'task-list-item-value': {
                                    'cursor': 'pointer',
                                }
                            },
                            events: {
                                click: ({ data }) => {
                                    console.log(data.listaResp);
                                }
                            },
                            html: true
                        }, {
                            id: 3,
                            label: 'Início',
                            value: 'inicio',
                            width: 72,
                            style: {
                                'task-list-header-label': {
                                    'font-weight': 'bold',
                                    'text-align': 'center',
                                }
                            },
                        }, {
                            id: 4,
                            label: 'Fim',
                            value: 'fim',
                            width: 72,
                            style: {
                                'task-list-header-label': {
                                    'font-weight': 'bold',
                                    'text-align': 'center',
                                }
                            },
                        }, {
                            id: 5,
                            label: '%',
                            value: 'progress',
                            width: 35,
                            style: {
                                'task-list-header-label': {
                                    'font-weight': 'bold',
                                    'text-align': 'center',
                                },
                                'task-list-item-value-container': {
                                    'text-align': 'center',
                                    'width': '100%',
                                },
                            },
                        }
                    ]
                }
            }
        }
    },
    methods: {
        limparFiltro() {
            this.filtro = {
                ordem: 5
            }
            this.carregarProjetos();
        },
        filtrarTipo() {
            if (this.filtroTipo === "") {
                this.listaProjeto = this.listaProjetoFiltro;
            } else {
                this.listaProjeto = this.listaProjetoFiltro.filter((item) => {
                    return (
                        item.nomeCodigo.toUpperCase().indexOf(this.filtroTipo.toUpperCase()) >= 0 ||
                        item.dataInicio.indexOf(this.filtroTipo.toUpperCase()) >= 0 ||
                        item.dataFim.indexOf(this.filtroTipo.toUpperCase()) >= 0 ||
                        item.situacaoDescricao.toUpperCase().indexOf(this.filtroTipo.toUpperCase()) >= 0 ||
                        item.classificacaoDescricao.toUpperCase().indexOf(this.filtroTipo.toUpperCase()) >= 0
                    );
                });
            }
        },
        carregarTela() {
            this.listaInvestimento = [{ codigo: "MAIOR", descricao: "Maior igual a" }, { codigo: "MENOR", descricao: "Menor igual a" }, { codigo: "IGUAL", descricao: "Igual a" }]
            this.$clubApi.get("/enum/classificacao").then((retorno) => {
                this.listaClassificacao = retorno.data.object;
            });
            this.$clubApi.get("/enum/relevancia").then((retorno) => {
                this.listaRelevancia = retorno.data.object;
            });
            this.$clubApi.get("/user/responsaveis").then((retorno) => {
                this.listaUsuarios = retorno.data.object;
            });
            this.$clubApi.get("/estrutura/gt/ativo").then((retorno) => {
                this.listaGT = retorno.data.object;
            });
            this.$clubApi.get("/atividade/tipos").then((retorno) => {
                this.listaTipoAtividade = retorno.data.object;
            });
        },
        carregarProjetos() {
            this.progress = true;
            this.$clubApi.post("/projeto/painelfiltro", this.filtro).then((response) => {
                this.listaProjeto = response.data.object;
                this.listaProjetoFiltro = response.data.object;

                for (const p of this.listaProjeto) {
                    let projeto = {
                        id: p.id,
                        codigo: p.codigo,
                        codigoNome: p.codigo + " - " + p.titulo,
                        titulo: p.titulo,
                        label: p.titulo,
                        user: p.responsavel,
                        start: p.dataStart,
                        inicio: p.dataInicio,
                        fim: p.dataFim,
                        duration: p.duracao * 24 * 60 * 60 * 1000,
                        duracao: p.duracao,
                        progress: p.progresso,
                        type: p.tipoProjeto,
                        classificacao: p.classificacao,
                        relevancia: p.relevancia,
                        dataConclusao: p.dataConclusao,
                        listaGT: p.listaGT,
                        listaResp: p.listaResp,
                        situacao: p.situacao,
                        style: {
                            'chart-row-bar': {
                                cursor: 'pointer',
                            },
                            'chart-row-bar-polygon': {
                                stroke: (p.situacao == "Atrasado") ? '#8B0000' : '#0EAC51',
                                fill: (p.situacao == "Atrasado") ? '#FF0000' : '#1EBC61',
                            },
                            /*
                            'chart-row-progress-bar-outline': {
                                stroke: '#0EAC30',
                            },
                            */
                        }
                    }
                    this.tasks.push(projeto);
                }
            })
            .catch((error) => {
                this.$toastr.warning(error);
            })
            .finally(() => {
                this.progress = false;
                const todayButton = document.querySelector('.gantt-elastic__header-btn-recenter');
                if (todayButton) {
                    todayButton.click();
                }
                const divElement = document.getElementById('collapseFiltroBTN');
                divElement.click();
            });
        },
        abrirModalProjeto(data) {
            this.projeto = data;
            this.modals.modalProjeto = true;
        },
        fecharModalProjeto() {
            this.projeto = {};
            this.modals.modalProjeto = false;
        },
        obterData(horas) {
            const currentDate = new Date();
            const currentYear = currentDate.getFullYear();
            const currentMonth = currentDate.getMonth() + 1;
            const currentDay = currentDate.getDate();
            const timeStamp = new Date(`${currentYear}-${currentMonth}-${currentDay} 00:00:00`).getTime();
            return new Date(timeStamp + horas * 60 * 60 * 1000);
        },
        formatarData(horas) {
            let dataVar = this.obterData(horas);
            return dataVar.getDate().toString().padStart(2, '0') + "/" + (dataVar.getMonth() + 1).toString().padStart(2, '0') + "/" + dataVar.getFullYear();
        },
        getFirstAndLastDayOfYear() {
            const currentDate = new Date(); // Obter a data atual
            const currentYear = currentDate.getFullYear(); // Obter o ano corrente

            // Primeiro dia do ano corrente
            const firstDayOfYear = new Date(currentYear, 0, 1);
            const formattedFirstDay = this.formatDate(firstDayOfYear);

            // Último dia do ano corrente
            const lastDayOfYear = new Date(currentYear, 11, 31);
            const formattedLastDay = this.formatDate(lastDayOfYear);

            return { firstDayOfYear: formattedFirstDay, lastDayOfYear: formattedLastDay };
        },
        formatDate(date) {
            // Função para formatar a data no formato "dd/mm/yyyy"
            const day = date.getDate();
            const month = date.getMonth() + 1;
            const year = date.getFullYear();
            
            // Adicionar zero à esquerda se for necessário
            const formattedDay = day < 10 ? `0${day}` : day;
            const formattedMonth = month < 10 ? `0${month}` : month;

            return `${formattedDay}/${formattedMonth}/${year}`;
        },
        getDateRange() {
            // Obter a data de hoje
            const today = new Date();

            // Subtrair 6 meses da data de hoje para obter a data de início
            const startDate = new Date(today.getFullYear(), today.getMonth() - 3, today.getDate());
            // Adicionar 6 meses à data de hoje para obter a data de fim
            const endDate = new Date(today.getFullYear(), today.getMonth() + 3, today.getDate());

            return {
            startDate: this.formatDate(startDate),
            endDate: this.formatDate(endDate)
            };
        }
    },
    mounted() {
    this.$nextTick(() => {
        const container = document.querySelector('.gantt-container');
        if (container) {
            const parentHeight = container.clientHeight; // Altura do contêiner pai
            const newMaxHeight = parentHeight * 0.5; // Definindo a altura máxima como 90% da altura do contêiner pai
            this.options.maxHeight = newMaxHeight;
        }
    });
},
};
</script>
<style>
.clickable {
    cursor: pointer;
}

.font-13 {
    font-size: 13px;
}
</style>